// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.parent-nav-item {
  display: flex;
  justify-content: center;
  font-size: 16px;
  color: white;
  position: relative;
  align-items: center;
}
.tab-parent {
  display: flex;
  border-right: 1px solid white;
}
.tab-parent-open {
  background-color: #045976;
}
.tab-parent-selected {
  background-color: #045976;
}
.dd-chevron svg:hover {
  fill: white;
}
.parent-nav-item svg:hover {
  fill: white;
}
.top-level-icon {
  padding-right: 5px;
}
.tab-icon-slot {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  flex-shrink: 0;
}
.tab-icon-slot .top-level-icon {
  padding-right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}
/* SVGs inside the slot may lose their intrinsic width in nested flex context;
   overflow: visible ensures the content renders regardless */
.tab-icon-slot .top-level-icon svg {
  overflow: visible;
}
.top-level-close-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.nav-dropdown {
  position: absolute;
  left: -10px;
  top: 40px;
  width: fit-content;
  min-width: 300px;
  max-width: 400px;
  z-index: 2;
  min-height: 100px;
  background: white;
  border-bottom: 1px solid gray;
  border-right: 1px solid gray;
  border-left: 1px solid gray;
  box-shadow: 0 19px 19px rgba(0, 0, 0, 0.26);
  overflow-x: hidden;
}
.nav-dropdown-header {
  height: 10px;
  background-color: #045976;
}

.parent-top-level-nav-item {
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  overflow-x: hidden;
  padding-left: 4px;
  padding-right: 4px;
  padding-bottom: 4px;
  border-top: 1px #707070 solid;
  min-height: 40px;
  margin-top: 10px;
  max-height: 400px;
}
`, "",{"version":3,"sources":["webpack://./src/components/topLevelNav/components/topLevelParentNavItem/style.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,6BAA6B;AAC/B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;AACA;6DAC6D;AAC7D;EACE,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,UAAU;EACV,iBAAiB;EACjB,iBAAiB;EACjB,6BAA6B;EAC7B,4BAA4B;EAC5B,2BAA2B;EAC3B,2CAA2C;EAC3C,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,6BAA6B;EAC7B,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;AACnB","sourcesContent":[".parent-nav-item {\n  display: flex;\n  justify-content: center;\n  font-size: 16px;\n  color: white;\n  position: relative;\n  align-items: center;\n}\n.tab-parent {\n  display: flex;\n  border-right: 1px solid white;\n}\n.tab-parent-open {\n  background-color: #045976;\n}\n.tab-parent-selected {\n  background-color: #045976;\n}\n.dd-chevron svg:hover {\n  fill: white;\n}\n.parent-nav-item svg:hover {\n  fill: white;\n}\n.top-level-icon {\n  padding-right: 5px;\n}\n.tab-icon-slot {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  flex-shrink: 0;\n}\n.tab-icon-slot .top-level-icon {\n  padding-right: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n}\n/* SVGs inside the slot may lose their intrinsic width in nested flex context;\n   overflow: visible ensures the content renders regardless */\n.tab-icon-slot .top-level-icon svg {\n  overflow: visible;\n}\n.top-level-close-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n}\n.nav-dropdown {\n  position: absolute;\n  left: -10px;\n  top: 40px;\n  width: fit-content;\n  min-width: 300px;\n  max-width: 400px;\n  z-index: 2;\n  min-height: 100px;\n  background: white;\n  border-bottom: 1px solid gray;\n  border-right: 1px solid gray;\n  border-left: 1px solid gray;\n  box-shadow: 0 19px 19px rgba(0, 0, 0, 0.26);\n  overflow-x: hidden;\n}\n.nav-dropdown-header {\n  height: 10px;\n  background-color: #045976;\n}\n\n.parent-top-level-nav-item {\n  display: flex;\n  flex-direction: column;\n  overflow-y: auto;\n  overflow-x: hidden;\n  padding-left: 4px;\n  padding-right: 4px;\n  padding-bottom: 4px;\n  border-top: 1px #707070 solid;\n  min-height: 40px;\n  margin-top: 10px;\n  max-height: 400px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
